import React from 'react'
import PropTypes from 'prop-types'
import { AVAILABLE_ON_SOURCE } from 'domains/scraper-product/constants'
import StatusBadge from 'components/atoms/status-badge'


const propTypes = {
  isInStock: PropTypes.bool
}

const ScraperProductIsInStockBadge = ({ isInStock }) => {

  isInStock = isInStock ? 'yes' : 'no'

  const colorMap = {
    [AVAILABLE_ON_SOURCE.YES] : 'success',
    [AVAILABLE_ON_SOURCE.NO]  : 'danger'
  }

  const labelMap = {
    [AVAILABLE_ON_SOURCE.YES] : 'Yes',
    [AVAILABLE_ON_SOURCE.NO]  : 'No'
  }

  const color = colorMap[isInStock] || 'secondary'
  const label = labelMap[isInStock] || '-'

  return <StatusBadge color={ color } label={ label } />
}

ScraperProductIsInStockBadge.propTypes = propTypes

export default ScraperProductIsInStockBadge
